import React from 'react'
import './home.css'
const Home = () => {
  return (
    <div className='homepage'>
        <div className='mainhome'>
        <div className='homecard'>
                <h1 className='hometext1'>So, YOU WANT TO TRAVEL</h1>
                <h1 className='space'> SPACE</h1>
                <p className='face'>
                    lets face it: if you want to go space, you might also genuienly go to outer space and not hover on the edge of it. Well Sit back and relax b/c we give you a true Outer Space Expericence 
                </p>

            </div>
            <div className='explore'>
                Explore
            </div>

        </div>
            
    </div>
  )
}

export default Home